// Nearby Search Scripts
(function () {
    // Options Object - maximumAge (use ms - eg: 10 * 60 * 1000)
    // can use recent loc without starting up geo processes Geolocation
    const geoOptions = {
        maximumAge: 5 * 60 * 1000,
        timeout: 10 * 1000,
    };
    let userLatitude, userLongitude;
    // Which listing scope to redirect into (matches the view's filter_type:
    // "location" = Communities, "spec" = Homes). Set from the clicked
    // button's data-filter-type right before kicking off geolocation, since
    // getCurrentPosition's callbacks don't carry extra arguments through.
    let currentFilterType;
    document.addEventListener('DOMContentLoaded', () => {
        // A page can render more than one "Search Nearby" trigger (eg. a
        // homepage inline search box alongside the header search offcanvas).
        // Bind every instance instead of a single id so a duplicate doesn't
        // silently steal the only click listener.
        const searchNearbyBtnEls = document.querySelectorAll('.js-search-nearby');
        // On click
        // Get user lat/lng from browser, if possible, handle errors
        // Call ajax endpoint w lat/lng for redirect
        searchNearbyBtnEls.forEach((searchNearbyBtnEl) => {
            searchNearbyBtnEl.addEventListener('click', (e) => {
                currentFilterType = searchNearbyBtnEl.dataset.filterType;
                if (navigator.geolocation) {
                    try {
                        getUserLatLng();
                    } catch (e) {
                        console.error(`Sorry! There was an error getting your location.`);
                    }
                } else {
                    alert(`Sorry! Geolocation is not supported by this browser.`);
                }
            });
        });
        function getUserLatLng() {
            navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions);
        }
        // Success Callback Geolocation
        function geoSuccess(position) {
            let coords = position.coords;
            if (coords) {
                userLatitude = coords.latitude;
                userLongitude = coords.longitude;
                try {
                    handleMarketRedirect(userLatitude, userLongitude);
                } catch (e) {
                    console.error(e);
                }
            }
        }
        // Error Callback Geolocation
        function geoError(error) {
            console.error(`Error getting user geolocation: ${error.message}`);
        }
        // Call Market Redirect View
        function handleMarketRedirect(userLatitude, userLongitude) {
            const url = `/xhr/nearby-search/`;
            let data = {
                user_latitude: userLatitude,
                user_longitude: userLongitude,
                filter_type: currentFilterType,
            };
            data = JSON.stringify(data);
            oi.axios({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then((response) => {
                if (response?.data?.data?.redirect) {
                    window.location.href = response.data.data.redirect;
                }
            }).catch((error) => {
                if (!error.response) {
                    console.error('Nearby search request failed (no response):', error.message);
                    return;
                }
                if (error.response.data?.data?.redirect) {
                    window.location.href = error.response.data.data.redirect;
                } else {
                    console.error(error.response.data?.data?.message || 'Nearby search failed.');
                }
            });
        }
    });
})();
